'use client'
import { Prisma } from '@prisma/client'
import { usePathname, useRouter } from 'next/navigation'
import React, { useEffect, useMemo, useState } from 'react'
import Select from 'react-select'

type Props = {
    tgis: Prisma.TgiGetPayload<{}>[]
    searchParams: URLSearchParams
}

const FilterVentesTribunal = ({ tgis, searchParams }: Props) => {
    
    const pathName = usePathname()
    const params = useMemo(() => new URLSearchParams(searchParams), [searchParams])
    const router = useRouter()

    const [tgiSelected, setTgiSelected] = useState<string>()

    const handleChange = async (tgiId: string) => {

        // suppression des paramètres de departement
        params.delete('tgi')
        params.set('page', '1')

        // ajout du nouveau paramètre de departement
        if (tgiId) {
            params.append('tgi', tgiId)
        }

        setTgiSelected(tgiId)
        router.push(pathName + '?' + params.toString())
    };

    useEffect(() => {
        if (params.has('tgi')) {
            setTgiSelected(`${params.get('tgi')}`)
        } else {
            setTgiSelected(undefined)
        }
    }, [params])

    return (
        <div className="w-full lg:w-1/3">
            <Select
                id='select-tgis'
                className="basic-single"
                placeholder="Tribunal Judiciaire"
                styles={{
                    control: (provided: any) => ({
                        ...provided,
                        width: '100%',
                    }),
                    container: (provided: any) => ({
                        ...provided,
                        width: '100%',
                    }),
                    menu: (provided: any) => ({
                        ...provided,
                        width: '100%',
                        zIndex: 600
                    }),
                }}
                options={tgis}
                getOptionLabel={(option: any) => {
                    const ville = option.ville;
                    const prefix = /^[aeiouyAEIOUY]/.test(ville) ? "d'" : "de ";
                    return `Tribunal judiciaire ${prefix}${ville}`;
                }}
                getOptionValue={(option: any) => option.id!.toString()}
                noOptionsMessage={() => "Aucun Tribunal correspondant"}
                isClearable={true}
                isSearchable={true}
                onChange={(selectedOption: any) => {
                    handleChange(selectedOption?.id)
                }}
                value={tgis.find((tgi) => tgi.id.toString() === tgiSelected) ?? null}
                aria-label='Filtre Tribunal'
            />
        </div>
    )
}

export default FilterVentesTribunal